import { slotInit } from "./slotInit.js";

export async function preloader(scope, ctx) {
    const { scenes, resources } = ctx;

    const scene = await scenes.show("PreloaderScene");

    await resources.load(["main", "ui", "sounds", "numbers", "big_win"], {
        onProgress: (progress) => scene.setProgress(progress * 100),
    });

    scope.defer(() => scenes.hide("PreloaderScene"));

    return slotInit;
}
